import { BlobProvider, PDFViewer } from "@react-pdf/renderer";
import { Style } from "@react-pdf/types";
import { ReactNode } from "react";
import styled from "styled-components";
import CiContent from "./CiContent";
import { CiData } from "./types";

interface CiPreviewProps {
  /**
   * @description PDF 필드의 title, value, hidden 필수값
   * data만 있어도 pdf 미리보기가 가능합니다
   * */
  data: CiData;
  trigger?: ReactNode;

  /**
   * @description PDF URL 원본을 구하기 위한 함수
   * URL로 새창을 띄우면 브라우저 내장 PDF View 실행
   */
  getUrl?: (url: string | null) => void;
  getBlob?: (file: Blob | null) => void;
  previewStyle?: Style | Style[];
}

function CiPreview({
  trigger,
  data,
  getUrl,
  getBlob,
  previewStyle,
}: CiPreviewProps) {
  const renderDocument = () => {
    return <CiContent data={data} />;
  };

  const renderPreview = () => {
    const mergedStyle = previewStyle
      ? { width: "100%", ...(previewStyle as any) }
      : { width: "100%" };
    
    return (
      <PDFViewer style={mergedStyle}>
        {renderDocument()}
      </PDFViewer>
    );
  };

  return (
    <>
      {trigger ? (
        <BlobProvider document={renderDocument()}>
          {({ blob, url }) => {
            getBlob && getBlob(blob);
            getUrl && getUrl(url);

            return (
              <Anchor
                href={url === null ? "" : url}
                target="_blank"
                rel="noreferrer"
              >
                {trigger}
              </Anchor>
            );
          }}
        </BlobProvider>
      ) : (
        renderPreview()
      )}
    </>
  );
}

export default CiPreview;

const Anchor = styled.a`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  text-decoration: none;
  color: initial;
  font-size: initial;
  display: inline-block;
`;
